// extracted by mini-css-extract-plugin
export default {"cuadroTrabajo":"GrupoTrabajo_cuadroTrabajo__p7fL2","subtitulo":"GrupoTrabajo_subtitulo__3lQei"};